/** Format a volume stored in m³, scaling to cm³ or mm³ when the value is very small. */
export function formatVolumeFromM3(quantityM3: number | string): string {
  const formatValue = (value: number, fractionDigits: number): string => {
    return value.toFixed(fractionDigits).replace(/\.?0+$/u, ''); // Remove trailing zeros
  };
  const value = Number(quantityM3);
  if (!Number.isFinite(value) || value <= 0) {
    return '0 m³';
  }
  if (value >= 1) {
    return `${formatValue(value, 4)} m³`;
  }
  if (value >= 0.01) {
    return `${formatValue(value, 6)} m³`;
  }
  if (value >= 0.000001) {
    return `${formatValue(value * 1e6, 2)} cm³`;
  }
  return `${formatValue(value * 1e9, 2)} mm³`;
}

/**
 * Reformat a pricing-information volume string (always treated as display text).
 */
export function formatVolumeDisplayValue(value: string): string | null {
  const match = value.trim().match(/^([0-9.,]+)\s*(m³|cm³|mm³)$/u);
  if (!match) {
    return null;
  }

  const amount = Number.parseFloat(match[1].replace(/,/g, ''));
  if (!Number.isFinite(amount)) {
    return null;
  }

  const unit = match[2];
  const quantityM3 =
    unit === 'm³' ? amount : unit === 'cm³' ? amount / 1e6 : amount / 1e9;

  return formatVolumeFromM3(quantityM3);
}
